import { ExerciseHeader } from "components/Common/ExerciseHeader";
import { Space } from "components/Common/Space";
import {
  useUpdateChapterStudentProgress,
  useUpdateHomeworkStudentProgress,
} from "hooks/api/student-progress";
import { useRole } from "hooks/common";
import { useParams } from "react-router-dom";
import { TrueOrFalseCarousel } from "./Carousel";
import {
  TTrueOrFalseExercise,
  TTrueOrFalseExercisePayload,
} from "types/app/exercises";
import "./TrueOrFalse.styles.scss";

type TTrueOrFalseProps = {
  isHomeworkExercise: boolean;
  /**
   * Chapter ID to which the exercise belongs.
   */
  chapterId: number;
  /**
   * An exercise raw data from API response.
   */
  exercise: TTrueOrFalseExercise;
  /**
   * Lesson chapter order number with the exercise sequence number to display before the exercise condition.
   * @default null
   */
  prefix?: string | null;
};

export const TrueOrFalse: React.FC<TTrueOrFalseProps> = (props) => {
  const { chapterId, exercise, prefix, isHomeworkExercise } = props;

  const { courseId, lessonId, studentId } = useParams();
  const { isUserStudent } = useRole();

  const { mutate: updateChapterProgress } = useUpdateChapterStudentProgress(
    courseId,
    lessonId,
    chapterId,
    studentId
  );
  const { mutate: updateHomeworkProgress } = useUpdateHomeworkStudentProgress(
    courseId,
    lessonId,
    chapterId,
    studentId
  );

  const handleUpdateExercise = (updatedExercise: TTrueOrFalseExercise) => {
    if (!isUserStudent || !studentId) return;

    if (isHomeworkExercise) {
      updateHomeworkProgress(updatedExercise);
    } else {
      updateChapterProgress(updatedExercise);
    }
  };

  return (
    <Space direction="vertical" size="medium" justify="start" fullWidth>
      <ExerciseHeader<TTrueOrFalseExercisePayload>
        chapterId={chapterId}
        exercise={exercise}
        prefix={prefix}
      />
      <TrueOrFalseCarousel
        chapterId={chapterId}
        exercise={exercise}
        answers={exercise.payload.data.answers}
        onUpdateExercise={handleUpdateExercise}
      />
    </Space>
  );
};
